<p>minimal-invoice-template works!</p>
